// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header-inner":"Header_header-inner__LR7tJ","header-logo":"Header_header-logo__ASrxG","nav":"Header_nav__IIF23"};